import { FirebaseState } from "../../services/firebase/ReadleeFirebaseProvider";
import ReadleeProfile from "../../services/firebase/ReadleeProfile";
import UserSettings from "../../interfaces/UserSettings";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { dispatch } from "../configureStore";

// Creator for the currently logged in user.
const initialState: FirebaseState = {
  isConnectingUser: true,
  isConnectingSettings: true,
  currentUser: undefined,
  currentUserSettings: undefined,
  userType: "",
  assumedUserType: "",
};

const slice = createSlice({
  name: "currentUserState",
  initialState,
  reducers: {
    setConnectingUser: (state, action: PayloadAction<boolean>) => {
      state.isConnectingUser = action.payload;
    },
    setConnectingSettings: (state, action: PayloadAction<boolean>) => {
      state.isConnectingSettings = action.payload;
    },
    signIn: (state, action: PayloadAction<ReadleeProfile>) => {
      state.currentUser = action.payload;
      state.isConnectingUser = false;

      if (state.currentUser.userType === "student" || state.currentUser.userType === "teacher") {
        state.userType = state.currentUser.userType;
      } else {
        state.userType = "";
      }

      state.assumedUserType = state.userType;
    },
    updateUserData: (state, action: PayloadAction<ReadleeProfile>) => {
      state.currentUser = action.payload;
      state.isConnectingUser = false;
      if (state.currentUser.userType === "student" || state.currentUser.userType === "teacher") {
        state.userType = state.currentUser.userType;
      } else {
        state.userType = "";
      }

      state.assumedUserType = state.userType;
    },
    setUserSettings: (state, action: PayloadAction<UserSettings>) => {
      state.currentUserSettings = action.payload;
      state.isConnectingSettings = false;
    },
    signOut: state => {
      state.currentUser = undefined;
      state.currentUserSettings = undefined;
      state.isConnectingUser = false;
      state.isConnectingSettings = false;
    },
  },
});

export type { FirebaseState };

export const setConnectingUser = (isConnecting: boolean): void => {
  dispatch(slice.actions.setConnectingUser(isConnecting));
};

export const setConnectingSettings = (isConnecting: boolean): void => {
  dispatch(slice.actions.setConnectingSettings(isConnecting));
};

export const setUserSettings = (settingsData: UserSettings): void => {
  dispatch(slice.actions.setUserSettings(settingsData));
};

export const signIn = (userData: ReadleeProfile): void => {
  dispatch(slice.actions.signIn(userData));
};

export const signOut = (): void => {
  dispatch(slice.actions.signOut());
};

export const updateUserData = (userData: ReadleeProfile): void => {
  dispatch(slice.actions.updateUserData(userData));
};

export default slice.reducer;
